// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85e1e1f4","455":"37d534b4","977":"c899ba5a"}[chunkId] + ".chunk.js";
};